/*eslint-disable*/
import api from '../'

class BonusesApi {
    static list(params, cancelToken = null) {
        return api.axios.get('/bonus-games', {params, cancelToken})
            .then(response => response.data);
    }

    static update (params) {
        return api.axios.post('/bonus-games-update/', params)
            .then(response => response.data);
    }

    static checkAccessForBonusGame (params) {
        return api.axios.post('/bonus-games/access/', params)
            .then(response => response.data);
    }

    static checkAccessForBonusGameForHomework (params) {
        return api.axios.post('/bonus-games/access-for-homework/', params)
            .then(response => response.data);
    }

    static getAccessForBonusGamesForCourse(params) {
        return api.axios.get('/bonus-games/access-for-course/', { params })
            .then(response => response.data);
    }
}

export default BonusesApi;